import React from 'react'
import Testimonials from './Testimonials'

export default function ServiceTestimonials({testimonials}) {

  if ((testimonials != null) && (testimonials.edges != null) && (testimonials.edges.length > 0)) {
    return <Testimonials testimonials={testimonials.edges} />
  }

}
